"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

// App Router init for the INP RUM observer. Dynamic-import keeps the module
// out of the LCP-critical path; init runs once after first paint.
export default function RumInit(): null {
  const pathname = usePathname();

  useEffect(() => {
    let cancelled = false;
    import("src/utils/rum/inpCapture")
      .then(({ initRum }) => {
        if (!cancelled) {
          initRum();
        }
      })
      .catch(() => {
        /* never throw from RUM */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Per-route INP: flush + reset the accumulator when the pathname changes.
  // (Initial mount also runs this; reset is a no-op with nothing recorded yet.)
  useEffect(() => {
    import("src/utils/rum/inpCapture")
      .then(({ resetForRoute }) => resetForRoute())
      .catch(() => {
        /* never throw from RUM */
      });
  }, [pathname]);

  return null;
}
